import React from 'react';
import CopyIcon from '../../../icons/general/CopyIcon';
import type { BoletoDetailsProps } from '../types/boleto-payment.types';
import BoletoIcon from '../../../icons/payment/BoletoIcon';
//import Barcode from "react-barcode";

const BoletoDetails: React.FC<BoletoDetailsProps> = ({ paymentDetails, onCopyCode, codeCopied }) => {
  const displayDueDate = new Date().toLocaleDateString();

  const codeToDisplay = paymentDetails.digitableLine;
  const pdfUrl = paymentDetails.pdf || '#';

  return (
    <>
      <div className="bg-gray-50 dark:bg-gray-700 p-6 rounded-lg shadow-sm mb-6">
        {/* Data de vencimento */}
        <div className="mb-4">
          <p className="text-sm text-text-secondary dark:text-gray-300">Vencimento:</p>
          <p className="text-xl font-semibold text-red-600 dark:text-red-500" aria-label={`Data de vencimento: ${displayDueDate}`}>
            {displayDueDate}
          </p>
        </div>

        {/* Linha digitável */}
        <div className="mb-4">
          <p className="text-sm text-text-secondary dark:text-gray-300 mb-1">Linha Digitável:</p>
          <div className="flex flex-col sm:flex-row items-stretch sm:items-center">
            <p 
              className="flex-grow p-3 bg-gray-100 dark:bg-gray-800 border border-medium-gray dark:border-gray-600 rounded-l-md rounded-r-md
               sm:rounded-r-none text-sm text-text-primary dark:text-gray-200 break-all font-mono mb-2 lg:!mb-0"
              aria-label="Linha digitável do boleto"
            >
              {codeToDisplay}
            </p>
            <button
              onClick={() => onCopyCode(String(codeToDisplay))}
              disabled={!codeToDisplay || codeToDisplay === 'N/A'}
              className="w-full sm:w-auto flex items-center justify-center bg-primary text-white font-semibold py-3 px-4 rounded-r-md rounded-l-md sm:rounded-l-none hover:bg-primary-dark transition duration-150 text-sm disabled:opacity-50 disabled:cursor-not-allowed"
              aria-label="Copiar linha digitável do boleto"
            >
              <CopyIcon className="w-4 h-4 mr-2" />
              {codeCopied ? 'Copiado!' : 'Copiar Código'}
            </button>
          </div>
        </div>

        {/* Código de barras 
        {paymentDetails.barcode && (
          <div className="mt-4 text-center">
            <p className="text-sm text-text-secondary dark:text-gray-300 mb-2">Código de Barras:</p>
             <Barcode 
              value={paymentDetails.barcode} 
              height={80} 
              displayValue={true}
            />
          </div>
        )}*/}
      </div>

      {/* PDF */}
      <div className="mb-6 text-center">
        <a
          href={pdfUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center justify-center bg-dark-gray dark:bg-gray-600 text-white font-semibold py-3 px-6 rounded-lg hover:bg-gray-800 dark:hover:bg-gray-500 transition duration-150 text-base"
          aria-label="Abrir PDF do boleto em nova aba"
        >
          <BoletoIcon className="w-5 h-5 mr-2" />
          Visualizar / Imprimir Boleto (PDF)
        </a>
      </div>
    </>
  );
};

export default BoletoDetails;
